<app-header></app-header>
<app-menu></app-menu>
<div class="col-md-12">
    <iframe [src]="urlSafe" frameborder="0" style="
    width: 96vw;
    height: 90vh;
"></iframe>
</div>